import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalButtons} from 'shared/components/modals';
import EmployeeErrors from '../../EmployeeErrors';

const EmployeeErroredModal = observer(({modalOpen, uiState}) => {
  const {selectedEmployee} = uiState;

  if (!selectedEmployee) return null;

  return (
    <Modal
      size='md'
      title={'nmbr.employees.directory.Employee Added with Errors'}
      isOpen={modalOpen}
    >
      <div className='mb2 jumbo'><FormattedMessage id='nmbr.employees.directory.EMPLOYEE_ADDED_WITH_ERRORS' values={{name: selectedEmployee.name}}/></div>
      <EmployeeErrors nmbrEmployee={selectedEmployee}/>
      <ModalButtons
        cancelCaption='nmbr.employees.directory.Close'
        onCancel={() => uiState.closeEmployeeErroredModal()}
        hideSave
      />
    </Modal>
  );
});

export default EmployeeErroredModal;
